import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@store/store";

const initialState = {
  tokenData: {
    token: "",
    tokenexpires: "",
    portalProtected: false,
  },
};

const authSlice = createSlice({
  name: "tokenData",
  initialState,
  reducers: {
    setTokenData(state, action) {
      state.tokenData = action.payload;
    },
  },
});

export const { setTokenData } = authSlice.actions;

export const selectIsAuthenticated = (state: RootState) => {
  const { token, tokenexpires } = state.tokenData.tokenData;

  if (!token) return false;
  const tokenExpiresNumber = Number(tokenexpires + "000");
  if (isNaN(tokenExpiresNumber)) return false;

  return tokenExpiresNumber > Date.now();
};

export const selectToken = (state: RootState) =>
  state.tokenData.tokenData.token;

export default authSlice.reducer;
